<div class="row front-facing">
    <div class="col-12">
        <div class="edtell-card p-3">
            <ng-content></ng-content>
        </div>
    </div>
</div>